import getElement from 'config/navigation/util/get-element';
import {Route} from 'react-router-dom';
import {RouteProps} from '..';
import getSubRoute from './get-sub-route';

const getRoute = ({path, element, subRoutes, permission}: RouteProps) => {
  return (
    <Route
      key={path}
      element={
        element &&
        getElement({
          element,
          permissions: [permission],
        })
      }
      {...{path}}>
      {subRoutes && subRoutes.map(getSubRoute)}
    </Route>
  );
};

export default getRoute;
